import React from 'react';
import HubspotForm from 'react-hubspot-form';
import {
  Dialog,
  Pane,
  Heading,
  Paragraph,
  Spinner
} from 'evergreen-ui';

/**
 * A reusable modal component that displays a HubSpot contact form
 *
 * @param {boolean} isShown - Whether the modal is visible
 * @param {function} onClose - Function to call when the modal is closed
 * @param {string} title - The title of the modal
 * @param {string} description - Optional description text to show above the form
 * @param {string} portalId - HubSpot portal ID
 * @param {string} formId - HubSpot form ID
 * @returns {React.Component}
 */
const ContactFormModal = ({
  isShown,
  onClose,
  title = "Contact Us",
  description = "We're here to help! Fill out the form below and we'll get back to you as soon as possible.",
  portalId = '47511468',
  formId = '2400c766-d7d9-44b7-b8ca-91c1822e2a61'
}) => {
  return (
    <Dialog
      isShown={isShown}
      title={title}
      onCloseComplete={onClose}
      hasFooter={false}
      width="500px"
    >
      <Pane>
        {description && (
          <Paragraph marginBottom={16}>
            {description}
          </Paragraph>
        )}

        <HubspotForm
          portalId={portalId}
          formId={formId}
          onSubmit={() => console.log('Form submitted!')}
          onReady={(form) => console.log('Form ready!')}
          loading={
            <Pane display="flex" alignItems="center" justifyContent="center" height={200}>
              <Spinner size={32} />
            </Pane>
          }
        />
      </Pane>
    </Dialog>
  );
};

export default ContactFormModal;
